import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api";

const TYPE_LABEL = {
  CUSTOMER: "고객사",
  VENDOR: "매입처",
  PARTNER: "협력사",
  FREELANCER: "프리랜서",
  GOV: "기관",
  INTERNAL: "내부",
};

export default function CompanyList() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  async function load(query = "") {
    setError("");
    try {
      const data = await api.get(`/companies${query ? `?q=${encodeURIComponent(query)}` : ""}`);
      setRows(data);
    } catch (err) {
      setError(err.message);
    }
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <div className="sstoa-topbar">
        <div>
          <h1 className="sstoa-title">업체 관리</h1>
          <p className="sstoa-sub">거래처와 담당자, 보관 문서를 한 곳에서 관리합니다.</p>
        </div>
        <Link to="/sstoa/companies/new" className="sstoa-btn sstoa-btn--primary">+ 업체 등록</Link>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          load(q);
        }}
        style={{ display: "flex", gap: 8, marginBottom: 16, maxWidth: 420 }}
      >
        <input
          className="sstoa-input"
          placeholder="업체명·사업자번호 검색"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <button className="sstoa-btn" type="submit">검색</button>
      </form>

      {error && <div className="sstoa-error">{error}</div>}

      <div className="sstoa-panel">
        {rows === null ? (
          <div className="sstoa-empty">불러오는 중…</div>
        ) : rows.length === 0 ? (
          <div className="sstoa-empty">등록된 업체가 없습니다. 우측 상단에서 새로 등록하세요.</div>
        ) : (
          <table className="sstoa-table">
            <thead>
              <tr>
                <th>업체명</th>
                <th>구분</th>
                <th>대표자</th>
                <th>사업자번호</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} onClick={() => navigate(`/sstoa/companies/${c.id}`)}>
                  <td style={{ fontWeight: 600 }}>{c.name}</td>
                  <td><span className="sstoa-tag">{TYPE_LABEL[c.type] || c.type}</span></td>
                  <td>{c.representative || "—"}</td>
                  <td>{c.biz_reg_no || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
